import { addSentences } from "./sentences";

class Question {
  public text: string;
  public buildModelPath: string;

  public answers: Answer[] = [];

  constructor(text: string, buildModelPath: string) {
    this.text = text;
    this.buildModelPath = buildModelPath;
  }
}

class Answer {
  public text: string;
  public icon: string;
  public hint: string;
  public yourCityText: string;
  public communityCityText: string;
  public colour: string;

  public carbonFootprint: number;
  public economicProsperity: number;
  public employment: number;
  public healthHappinessAndWellbeing: number;
  public wildlife: number;

  public carbonFootprintCopy = "";
  public economicProsperityCopy = "";
  public employmentCopy = "";
  public healthHappinessAndWellbeingCopy = "";
  public wildlifeCopy = "";

  public modelPath: string;

  public key: string;

  constructor(
    text: string,
    modelPath: string,
    carbonFootprint: number,
    economicProsperity: number,
    employment: number,
    healthHappinessAndWellbeing: number,
    wildlife: number,
    icon: string,
    hint: string,
    yourCityText: string,
    communityCityText: string,
    colour: string,
    key: string
  ) {
    this.text = text;

    this.carbonFootprint = carbonFootprint;
    this.economicProsperity = economicProsperity;
    this.employment = employment;
    this.healthHappinessAndWellbeing = healthHappinessAndWellbeing;
    this.wildlife = wildlife;

    this.hint = hint;
    this.modelPath = modelPath;
    this.icon = icon;
    this.yourCityText = yourCityText;
    this.communityCityText = communityCityText;

    this.colour = colour;

    this.key = key;
  }
}

const colourOne = "brand-pink";
const colourTwo = "brand-lightYellow2";
const colourThree = "brand-yellowGreen";
const colourFour = "brand-darkGreen";
const colourFive = "brand-orange";
const colourSix = "brand-lightBlue";

const questions: Question[] = [];

function awake() {
  const questionOne = new Question(
    "How will you power your city?",
    "question_1/Build"
  );

  const resultOne = "will power your city";
  const communityOne = "powers the community city";

  questionOne.answers.push(
    new Answer(
      "Wind Energy",
      "question_1/Wind",
      3,
      3,
      3,
      1,
      -1,
      "wind",
      "Wind Energy is good for the environment and the economy, but it may impact communities and local wildlife habitats.",
      `Wind energy ${resultOne}`,
      `Wind energy ${communityOne}`,
      colourOne,
      "wind"
    )
  );
  questionOne.answers.push(
    new Answer(
      "Coal and Gas",
      "question_1/Coal",
      -3,
      2,
      1,
      -1,
      -2,
      "burn",
      "Fossil fuels play an important role in our economy and lives, as well as powering the energy transition for the future, but CO2 emissions are high and must be cut.",
      `Coal and gas energy ${resultOne}`,
      `Coal and gas energy ${communityOne}`,
      colourOne,
      "coal"
    )
  );
  questionOne.answers.push(
    new Answer(
      "Hydrogen",
      "question_1/Hydrogen",
      2,
      2,
      2,
      0,
      -1,
      "atom",
      "Hydrogen is a clean energy source, but heavy industry could still impact local wildlife.",
      `Hydrogen energy ${resultOne}`,
      `Hydrogen energy ${communityOne}`,
      colourOne,
      "hydrogen"
    )
  );
  questionOne.answers.push(
    new Answer(
      "Nuclear",
      "question_1/Nuclear",
      1,
      3,
      3,
      0,
      0,
      "radiation",
      "Nuclear is a reliable energy source with few negative impacts.",
      `Nuclear energy ${resultOne}`,
      `Nuclear energy ${communityOne}`,
      colourOne,
      "nuclear"
    )
  );
  questionOne.answers.push(
    new Answer(
      "Solar Energy",
      "question_1/Solar",
      2,
      2,
      2,
      1,
      0,
      "sun",
      "Solar technology is advancing rapidly to make this a flexible and affordable low-carbon energy option.",
      `Solar ${resultOne}`,
      `Solar ${communityOne}`,
      colourOne,
      "solar"
    )
  );

  const questionTwo = new Question(
    "How will your citizens travel?",
    "question_2/Build"
  );

  const resultTwo = "Your citizens will travel by";
  const communityTwo = "Community citizens will travel by";

  questionTwo.answers.push(
    new Answer(
      "Walk",
      "question_2/Walk",
      3,
      -1,
      -2,
      2,
      3,
      "walking",
      "Walking is good for health and the enviroment but less people will spend money on, or be employed by transport.",
      `${resultTwo} walking`,
      `${communityTwo} walking`,
      colourTwo,
      "walk"
    )
  );

  questionTwo.answers.push(
    new Answer(
      "Petrol / Diesel Vehicles",
      "question_2/Petrol_Diesel_Vehicles",
      -3,
      1,
      2,
      -3,
      -1,
      "car",
      "Use of petrol and diesel vehicles rely on non-renewable fossil fuels which have a big carbon footprint. However, the industry does provide jobs for the local communities.",
      `${resultTwo} petrol and diesel vehicles`,
      `${communityTwo} petrol and diesel vehicles`,
      colourTwo,
      "petrol"
    )
  );

  questionTwo.answers.push(
    new Answer(
      "Cycle / Electric Bike",
      "question_2/Cycle",
      2,
      2,
      1,
      2,
      3,
      "bicycle",
      "Cycling has many benefits for both communities and the environment with hardly any drawbacks.",
      `${resultTwo} cycling`,
      `${communityTwo} cycling`,
      colourTwo,
      "cycle"
    )
  );

  questionTwo.answers.push(
    new Answer(
      "Public Transport",
      "question_2/Public_Transport",
      -1,
      1,
      2,
      -1,
      -1,
      "bus",
      "Public transport is better for the environment than petrol/diesel vehicles, but they still mostly rely on fossil fuels.",
      `${resultTwo} public transport`,
      `${communityTwo} public transport`,
      colourTwo,
      "public"
    )
  );

  questionTwo.answers.push(
    new Answer(
      "Electric Vehicle",
      "question_2/Electric_Vehicle",
      3,
      3,
      2,
      -1,
      1,
      "charging-station",
      "Electric vehicles are far better for the environment than diesel vehicles.",
      `${resultTwo} electric vehicles`,
      `${communityTwo} electric vehicles`,
      colourTwo,
      "electric"
    )
  );

  const questionThree = new Question(
    "How will you feed your citizens?",
    "question_3/Build"
  );

  const resultThree = "will feed your citizens";
  const communityThree = "will feed the citizens of the community city";

  questionThree.answers.push(
    new Answer(
      "Grow local produce",
      "question_3/Grow_local_produce",
      2,
      1,
      3,
      3,
      -1,
      "seedling",
      "Locally grown produce has many benefits but more areas will need to be turned into farmland.",
      `Grown local produce ${resultThree}`,
      `Grown local produce ${communityThree}`,
      colourThree,
      "grow"
    )
  );
  questionThree.answers.push(
    new Answer(
      "Import food from abroad",
      "question_3/Import_food",
      -3,
      -1,
      -1,
      0,
      -1,
      "plane",
      "Importing food is very bad for the environment and for the economy.",
      `Imported food from abroad ${resultThree}`,
      `Imported food from abroad ${communityThree}`,
      colourThree,
      "import"
    )
  );
  questionThree.answers.push(
    new Answer(
      "Use local shops",
      "question_3/Use_local_shops",
      2,
      1,
      3,
      0,
      0,
      "shopping-basket",
      "When food is sourced locally, using local shops can boost the economy whilst minimising carbon emissions.",
      `Local shops ${resultThree}`,
      `Local shops ${communityThree}`,
      colourThree,
      "local"
    )
  );

  questionThree.answers.push(
    new Answer(
      "Visit Supermarket",
      "question_3/Visit_Supermarket",
      -1,
      2,
      2,
      0,
      -1,
      "shopping-cart",
      "Supermarkets may source food regionally, but many rely on imports, increasing the carbon footprint significantly. It also encourages more cars on the road and often more food waste.",
      `Supermarkets ${resultThree}`,
      `Supermarkets ${communityThree}`,
      colourThree,
      "supermarket"
    )
  );

  questionThree.answers.push(
    new Answer(
      "Shared homegrown food",
      "question_3/Share_homegrown",
      3,
      -2,
      -3,
      2,
      2,
      "users",
      "Sharing homegrown food with the community is good for the environment, but does not boost the economy.",
      `Community shared homegrown food ${resultThree}`,
      `Community shared homegrown food ${communityThree}`,
      colourThree,
      "shared"
    )
  );

  const questionFour = new Question(
    "What features will your houses and buildings have?",
    "question_4/Build"
  );

  const resultFour = "Your houses and buildings will feature";
  const communityFour =
    "The houses and buildings of the community city will feature";

  questionFour.answers.push(
    new Answer(
      "Assigned car parking space",
      "question_4/Assigned_car_parking",
      -3,
      1,
      0,
      -3,
      -2,
      "parking",
      "Tarmacking more land for parking will negatively impact the ecosystems and encourage use of cars; any economic benefits will not be local.",
      `${resultFour} extra car parking spaces`,
      `${communityFour} extra car parking spaces`,
      colourFour,
      "parking"
    )
  );
  questionFour.answers.push(
    new Answer(
      "Green rooftops and gardens",
      "question_4/Green_rooftops",
      3,
      1,
      2,
      2,
      3,
      "home",
      "Green rooftops and gardens offer many benefits to wildlife, health and wellbeing of communities, as well as helping to prevent flooding.",
      `${resultFour} green rooftops and gardens`,
      `${communityFour} green rooftops and gardens`,
      colourFour,
      "green"
    )
  );

  questionFour.answers.push(
    new Answer(
      "Solar panels",
      "question_4/Solar_panels",
      1,
      2,
      2,
      1,
      0,
      "solar-panel",
      "Advances in technology mean this renewable power source can be used in many buildings and locations with few negative impacts.",
      `${resultFour} solar panels`,
      `${communityFour} solar panels`,
      colourFour,
      "panels"
    )
  );

  questionFour.answers.push(
    new Answer(
      "Ample heating and A/C",
      "question_4/Ample_heating",
      -2,
      1,
      1,
      2,
      -1,
      "fan",
      "Extra heating and air conditioning will increase power consumption, but people will be more comfortable.",
      `${resultFour} ample heating and air conditioning`,
      `${communityFour} ample heating and air conditioning`,
      colourFour,
      "heating"
    )
  );

  questionFour.answers.push(
    new Answer(
      "Extra space and spare rooms",
      "question_4/Extra_space",
      -1,
      1,
      0,
      1,
      -1,
      "warehouse",
      "Extra space for houses has some benefits for comfort and wellbeing, but some drawbacks for CO2 emissions and land use.",
      `${resultFour} extra space and rooms`,
      `${communityFour} extra space and rooms`,
      colourFour,
      "extra"
    )
  );

  const questionFive = new Question(
    "What rules will you have for your citizens?",
    "question_5/Build"
  );

  const resultFive = "Your citizens will";
  const communityFive = "Community citizens will";

  questionFive.answers.push(
    new Answer(
      "Everyone must recycle",
      "question_5/Everyone_must_recycle",
      2,
      1,
      1,
      1,
      2,
      "recycle",
      "Recycling has many benefits across every aspect of life, reducing carbon footprint, increasing prosperity, and improving natural habitat.",
      `${resultFive} recycle`,
      `${communityFive} recycle`,
      colourFive,
      "recycle"
    )
  );

  questionFive.answers.push(
    new Answer(
      "Only one car per house",
      "question_5/Only_one_car_per_house",
      1,
      -1,
      -1,
      1,
      1,
      "car-side",
      "Minimising cars on the road significantly reduces CO2 emissions, but will directly affect the associated skilled workforce.",
      `${resultFive} only have one car per household`,
      `${communityFive} only have one car per household`,
      colourFive,
      "car"
    )
  );

  questionFive.answers.push(
    new Answer(
      "People grow their own food",
      "question_5/People_grow_their_own_food",
      3,
      -2,
      -3,
      3,
      3,
      "leaf",
      "Growing your own food boosts happiness, reduces the carbon footprint and positively affects wildlife. However, it's not so beneficial for the local economy and employment.",
      `${resultFive} grow their own food`,
      `${communityFive} grow their own food`,
      colourFive,
      "own"
    )
  );

  questionFive.answers.push(
    new Answer(
      "Extra food for everyone",
      "question_5/Extra_food_for_everyone",
      -2,
      1,
      1,
      -1,
      -1,
      "utensils",
      "More food for everyone can mean more land put to farming and more potential waste.",
      `${resultFive} have access to as much food as they want`,
      `${communityFive} have access to as much food as they want`,
      colourFive,
      "waste"
    )
  );

  questionFive.answers.push(
    new Answer(
      "Artificial plants and grass for everyone",
      "question_5/Artificial_plants",
      1,
      0,
      1,
      0,
      -2,
      "microscope",
      "Artificial plants and grass can use recycled materials and provide jobs, but in the main are not good for the environment, wildlife or flood resilience.",
      `${resultFive} have access to artificial plants and grass`,
      `${communityFive} have access to artificial plants and grass`,
      colourFive,
      "artificial"
    )
  );

  const questionSix = new Question(
    "How will your city make money?",
    "question_6/Build"
  );

  const resultSix = "Your city will make money from";
  const communitySix = "The community city will make money from";

  questionSix.answers.push(
    new Answer(
      "Technology and digital",
      "question_6/Technology_and_digital",
      2,
      3,
      3,
      0,
      0,
      "laptop-code",
      "Technology has many benefits to add to our sustainable future, adding opportunities for reducing carbon footprint, increasing employment and tackling issues of productivity.",
      `${resultSix} technology and digital`,
      `${communitySix} technology and digital`,
      colourSix,
      "tech"
    )
  );

  questionSix.answers.push(
    new Answer(
      "Manufacturing and construction",
      "question_6/Manufacturing_and_construction",
      -2,
      3,
      2,
      1,
      -1,
      "industry",
      "Manufacturing and construction boosts the economy, but can have a large carbon footprint.",
      `${resultSix} manufacturing and construction`,
      `${communitySix} manufacturing and construction`,
      colourSix,
      "construction"
    )
  );

  questionSix.answers.push(
    new Answer(
      "Fishing and farming",
      "question_6/Fishing_and_farming",
      -2,
      1,
      2,
      -1,
      -2,
      "tractor",
      "Fishing and farming has significant impacts on wildlife and the environment through large CO2 emissions, but will boost employment and the economy.",
      `${resultSix} fishing and farming`,
      `${communitySix} fishing and farming`,
      colourSix,
      "fishing"
    )
  );

  questionSix.answers.push(
    new Answer(
      "Renewable Energy",
      "question_6/Renewable_Energy",
      3,
      3,
      3,
      2,
      0,
      "power-off",
      "Renewable energy has many benefits for the economy and environment, and with management, very little negative impact to wildlife.",
      `${resultSix} renewable energy sources`,
      `${communitySix} renewable energy sources`,
      colourSix,
      "renewable"
    )
  );

  questionSix.answers.push(
    new Answer(
      "Attractions and Tourism",
      "question_6/Attractions_and_Tourism",
      -1,
      1,
      2,
      2,
      1,
      "landmark",
      "Attractions and toursim boosts wellbeing, wildlife and the economy, but a rise in travel has a negative impact on the environment.",
      `${resultSix} tourism and attractions`,
      `${communitySix} tourism and attractions`,
      colourSix,
      "attractions"
    )
  );

  questions.push(questionOne);
  questions.push(questionTwo);
  questions.push(questionThree);
  questions.push(questionFour);
  questions.push(questionFive);
  questions.push(questionSix);

  addSentences(questions);
}

export { Question, Answer, awake, questions };
